module.exports = __webpack_public_path__ + "img/left_white_arrow.eae18baa.svg";